import { i18n } from 'i18n';

type LocalizationDictionary = { [key: string]: string }
export default function useLocalizer<T extends LocalizationDictionary>(
    keyCollection: T,
    key: keyof T,
    options: object = null,
    namespace: string = 'translation',
) {
    return i18n.t(
        key as string,
        {
            ...options,
            defaultValue: keyCollection[key],
            ns: namespace,
            interpolation: { escapeValue: false },
        });
};